import { Link } from 'react-router-dom';
import { allArticles } from '@/utils/data';

const stats = [
  { value: `${allArticles.length}+`, label: '精选资讯' },
  { value: '4', label: '内容分类' },
  { value: '每日', label: '持续更新' },
  { value: '多端', label: '自适应阅读' },
];

export default function BrandIntro() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20warm%20gradient%20background%20with%20flowing%20light%20bokeh%2C%20modern%20media%20brand%20aesthetic%2C%20rich%20orange%20and%20deep%20amber%20tones%2C%20soft%20cinematic%20texture&width=1600&height=700&seq=brand-intro-2026&orientation=landscape"
          alt="色哟哟品牌介绍"
          title="色哟哟 - 多元娱乐资讯平台"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/70 to-accent-950/60"></div>

      <div className="relative z-10 w-full px-4 py-14 md:px-8 md:py-20">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/90 px-4 py-1.5 text-xs font-medium text-background-50">
            <i className="ri-sparkling-fill"></i>
            关于色哟哟
          </span>
          <h2 className="mt-4 text-2xl font-bold text-background-50 md:text-4xl">
            一个有态度的多元娱乐资讯平台
          </h2>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-100/80 md:text-base">
            色哟哟聚焦影视、音乐、明星动态与潮流趋势，坚持内容的时效性与多样性。我们既提供适合快速浏览的热点速览，也产出值得深度阅读的报道与策划，让每一位娱乐爱好者都能在这里找到自己想看的内容。
          </p>
          <div className="mt-8 grid max-w-2xl grid-cols-2 gap-4 sm:grid-cols-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-lg bg-background-50/10 p-4 backdrop-blur-sm">
                <div className="text-2xl font-bold text-primary-200">{s.value}</div>
                <div className="mt-1 text-xs text-background-100/70">{s.label}</div>
              </div>
            ))}
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              了解我们
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/category/trend"
              className="inline-flex items-center gap-2 rounded-md border border-background-50/30 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10 cursor-pointer whitespace-nowrap"
            >
              探索潮流
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}